import { render, staticRenderFns } from "./EstablishmentRoleInfo.vue?vue&type=template&id=51992865&"
import script from "./EstablishmentRoleInfo.vue?vue&type=script&lang=js&"
export * from "./EstablishmentRoleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports